module.exports = __webpack_public_path__ + "static/media/loading.7fc09f7a.gif";